import React, { useEffect, useState } from 'react';
import { useAuthContext } from '../contexts/AuthContext.js';

const ChannelList = ({
    // setActiveComponent, setSelectedUser, selectedUser,
    setActiveComponent,
    caseNames,
    selectedCaseId,
    setSelectedCaseId,
    topics,
    setTopics,
    setSelectedTopic,
    selectedtopic,
    selectedProjectData,
    setSelectedProjectData,
    meetings,
    setMeetings,
    setSelectedMeeting,
    selectedmeeting,
    ordersDetails, setOrdersDetails,
}) => {
    const [users, setUsers] = useState([]);
    const [currentUser, setCurrentUser] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState(false)
    const { AuthData, updateAuthData, setUser } = useAuthContext();


    // ✅ 初次載入：抓全部 order -> projects -> topics
    useEffect(() => {
        (async () => {
            try {
                const res = await fetch(`http://localhost:5000/get_orders_details`);
                const data = await res.json();
                setOrdersDetails(data.orders || []);
            } catch (err) {
                console.error("fetch get_orders_details error:", err);
            }
        })();
    }, []);

    const handleItClick = () => {
        setSelectedDM(!selectedDM);
    }

    const getProjectDetails = async (project) => {
        try {
            const res = await fetch(
                `http://localhost:5000/get_project_details/${encodeURIComponent(project.project_name)}`
            );
            const data = await res.json();

            // ✅ 這份 data 才有 tasks
            setSelectedProjectData(data);
            setTopics(data.topics);
        } catch (err) {
            console.error("fetch project_details error:", err);
        }
    }

    // 點 Case：只負責展開/選取 case
    const handleOrderClick = async (order) => {
        setSelectedCaseId(order.order_id);

        // ✅ 若你的 meetings 仍是 order_id 綁定，就留這段
        try {
            const resMeetings = await fetch(
                `http://localhost:5000/meetings?order_id=${order.order_id}`
            );
            const dataMeetings = await resMeetings.json();
            setMeetings(dataMeetings || []);
        } catch (err) {
            console.error("fetch meetings error:", err);
        }
    };

    // 點 Project：把 project 資料丟給父層 + 切換畫面 +（可選）載入 meetings
    const handleProjectClick = async (order, project) => {
        // setSelectedMeeting(null);
        // setSelectedTopic(null);
        getProjectDetails(project);
        setActiveComponent("Case");
    };

    // const handleClickCase = async (caseId) => {
    //     const orders_details = await fetch(`http://localhost:5000/get_orders_details`);
    //     const data_orders_details = await orders_details.json();
    //     console.log('handleClickCase data_orders_details:', data_orders_details)
    //     setOrdersDetails(data_orders_details.orders);

    //     console.log('caseId:', caseId)
    //     setSelectedCaseId(caseId);
    //     const res = await fetch(`http://localhost:5000/get_topics?order_id=${caseId}`);
    //     const data = await res.json();
    //     console.log('handleClickCase data:', data)
    //     setTopics(data.topics);

    //     const res_meetings = await fetch(`http://localhost:5000/meetings?order_id=${caseId}`);
    //     const data_meetings = await res_meetings.json();
    //     console.log('handleClickCase data_meetings:', data_meetings)
    //     setMeetings(data_meetings);
    // };

    const [selectedCase, setSelectedCase] = useState(null);
    const [selectedDM, setSelectedDM] = useState(false)

    // const handleCaseClick = async (caseName) => {
    //     // setSelectedCase(caseName === selectedCase ? null : caseName);
    //     setSelectedCase(caseName);
    //     setTopics([]);
    //     try {
    //         const response = await fetch(`http://localhost:5000/get_project_details/${encodeURIComponent(caseName)}`)
    //         const data = await response.json();
    //         console.log("SelectedProjectData:", data);
    //         console.log("Order ID:", data.order_id);
    //         console.log("Project ID:", data.project_id);
    //         console.log("Tasks:", data.tasks);
    //         // 可將資料存入 state 或導向新畫面
    //         setSelectedProjectData(data);           // 把資料傳到父層
    //         setActiveComponent('Case');            // 切換顯示元件
    //         handleClickCase(data.order_id);
    //     } catch (error) {
    //         console.error('Error fetching project_details:', error);
    //     }

    //     // fetch(`http://localhost:5000/get_project_details/${encodeURIComponent(caseName)}`)
    //     //   .then(res => res.json())
    //     //   .then(data => {
    //     //     console.log("Project ID:", data.project_id);
    //     //     console.log("Tasks:", data.tasks);
    //     //     // 可將資料存入 state 或導向新畫面
    //     //     setSelectedProjectData(data);           // 把資料傳到父層
    //     //     setActiveComponent('Case');            // 切換顯示元件
    //     //   })
    //     //   .catch(err => console.error(err));

    //     // handleClickCase(data.project_id);
    // };

    // 點 Topic：進 TopicChat（topic 來自 project.topics）

    const handleTopicClick = async (order, project, topic) => {
        setActiveComponent("")
        setSelectedMeeting(null)
        setSelectedTopic(topic)
        getProjectDetails(project);
        setActiveComponent("TopicChat")
    }

    const handleMeetingClick = (meeting, case_name) => {
        setActiveComponent("")
        // setSelectedTopic(null)
        setSelectedMeeting(meeting)
        // console.log("Channel selectedmeeting:", selectedmeeting)
        setActiveComponent("MeetingChat")
    }

    function formatDateShort(dateStr, showYear = false) {
        const d = new Date(dateStr);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const h = String(d.getHours()).padStart(2, "0");
        const min = String(d.getMinutes()).padStart(2, "0");
        return showYear ? `${y}/${m}/${day} ${h}:${min}` : `${m}/${day} ${h}:${min}`;
    }

    return (
        <>
            <div className="menu-item" onClick={handleItClick}>
                <img
                    src="./arrow02.png"
                    className={`arrow ${selectedDM ? "rotated" : ""}`}
                    alt="arrow"
                />
                <img src="./Hashtag.png" style={{ width: "18%" }} alt="hashtag" />
                <div>Channels</div>
            </div>

            <div className="item-option-container">
                {selectedDM && (
                    <div className="item-option-container">
                        {ordersDetails?.map((order) => (
                            <div key={order.order_id}>
                                {/* ✅ Case (Order) */}
                                <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleOrderClick(order)}
                                    className={`item-option ${selectedCaseId === order.order_id ? "selected-option" : ""
                                        }`}
                                >
                                    # {order.case_name}
                                </div>

                                {/* ✅ 展開：顯示 Projects */}
                                {selectedCaseId === order.order_id && (
                                    <div className="item-option-container" style={{ paddingLeft: 12 }}>
                                        <ul style={{ margin: 0, paddingLeft: 16 }}>
                                            {(order.projects || []).map((project) => (
                                                <li key={project.project_id} style={{ listStyle: "none" }}>
                                                    {/* ✅ Project */}
                                                    <div
                                                        style={{ cursor: "pointer" }}
                                                        className={`item-option ${selectedProjectData?.project.project_id === project.project_id
                                                            ? "selected-option"
                                                            : ""
                                                            }`}

                                                        onClick={() => handleProjectClick(order, project)}
                                                    >
                                                        ▸ {project.project_name || `(Project ${project.project_id})`}
                                                    </div>

                                                    {/* ✅ Topics under Project */}
                                                    {selectedProjectData?.project.project_id === project.project_id &&
                                                        (project.topics || []).length > 0 && (
                                                            <ul style={{ margin: 0, paddingLeft: 18 }}>
                                                                {(project.topics || []).map((topic) => (
                                                                    <li
                                                                        key={topic.topic_id}
                                                                        style={{ cursor: "pointer", listStyle: "none" }}
                                                                        onClick={() => handleTopicClick(order, project, topic)}
                                                                        className={`item-option ${selectedtopic?.topic_id === topic.topic_id
                                                                            ? "selected-option"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {topic.title}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )
                                                    }
                                                </li>
                                            ))}
                                        </ul>

                                        {/* ✅ Meetings（你原本是 order_id 綁定，我先放在 case 展開區） */}
                                        {(meetings || []).length > 0 && (
                                            <ul style={{ marginTop: 8, paddingLeft: 16 }}>
                                                {(meetings || []).map((meeting) => (
                                                    <li
                                                        key={meeting.id || meeting.start}
                                                        style={{ cursor: "pointer", listStyle: "none" }}
                                                        onClick={() => handleMeetingClick(meeting, order.case_name)}
                                                        className={`item-option ${selectedmeeting === meeting ? "selected-option" : ""
                                                            }`}
                                                    >
                                                        ▸ {formatDateShort(meeting.start, true)}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default ChannelList;



// <>
//     <div className="menu-item" onClick={() => handleItClick()}
//     >
//         <img
//             src="./arrow02.png"
//             className={`arrow ${selectedDM ? "rotated" : ""}`}
//             alt="arrow"
//         // onClick={handleClick}
//         />
//         <img src='./Hashtag.png' style={{ width: "18%" }}></img>
//         <div>Channels</div>
//     </div>
//     <div className='item-option-container'>
//         {/* {selectedCase && (<>
//             <div className='item-option'>1</div>
//             <div className='item-option'>2</div>
//         </>)} */}
//         {selectedDM && (

//             <div className='item-option-container'>
//                 {caseNames?.map((name, index) => (
//                     <>
//                         <div key={index}
//                             style={{ cursor: 'pointer' }}
//                             onClick={() => handleCaseClick(name)}
//                             className={`item-option ${selectedCase === name ? "selected-option" : ""}`}
//                         >
//                             # {name}
//                         </div>
//                         {selectedCase === name && (
//                             <div className='item-option-container'>

//                                 <dl>
//                                     <dt>Coffee</dt>
//                                     <dd>Black hot drink</dd>
//                                     <dt>Milk</dt>
//                                     <dd>White cold drink</dd>
//                                 </dl>
//                                 <ul>
//                                     {topics?.map((topic, index) => (
//                                         <li style={{ cursor: 'pointer' }}
//                                             onClick={() => handleTopicClick(topic)} key={index}
//                                             className={`item-option ${selectedtopic === topic ? "selected-option" : ""}`}
//                                         >
//                                             {topic.title}</li>))}
//                                 </ul>
//                                 <ul>
//                                     {meetings?.map((meeting, index) => (
//                                         <li style={{ cursor: 'pointer' }}
//                                             onClick={() => handleMeetingClick(meeting)}
//                                             key={index}
//                                             className={`item-option ${selectedmeeting === meeting ? "selected-option" : ""}`}
//                                         >
//                                             {/* {meeting.start} */}
//                                             {/* {new Date(meeting.start).toLocaleString("zh-TW", {
//                                                 year: "numeric",
//                                                 month: "2-digit",
//                                                 day: "2-digit",
//                                                 hour: "2-digit",
//                                                 minute: "2-digit",
//                                                 hour12: false,  // ✅ 24 小時制
//                                             })} */}
//                                             {formatDateShort(meeting.start, true)}
//                                         </li>))}
//                                 </ul>
//                             </div>
//                         )}
//                     </>
//                 ))}
//             </div>
//         )}
//     </div>
// </>